module.exports = __webpack_public_path__ + "img/feature-icon4.cf9ffff9.png";